/**
 * Put the cursor in a service row's "Add Service Name" field and open its dropdown, so a user who
 * clicks ADD SERVICE can type straight away without reaching for the mouse.
 *
 * Shared by the invoice, estimate and work order editors. The new row renders after the state
 * update, so this retries briefly until the input exists instead of guessing one fixed delay.
 *
 * @param {number} index row index of the service to focus
 */
export const focusServiceSearch = (index, { attempts = 20, interval = 75 } = {}) => {
    let tries = 0;

    const tryFocus = () => {
        const input = document.getElementById(`service-search-autocomplete-${index}`);

        if (!input) {
            tries += 1;
            if (tries < attempts) setTimeout(tryFocus, interval);
            return;
        }

        input.scrollIntoView({ block: 'center', behavior: 'smooth' });
        input.focus({ preventScroll: true });

        // Open the options list, as pressing ArrowDown in the field would.
        setTimeout(() => {
            input.dispatchEvent(
                new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    code: 'ArrowDown',
                    keyCode: 40,
                    which: 40,
                    bubbles: true,
                    cancelable: true,
                })
            );
        }, 150);
    };

    setTimeout(tryFocus, interval);
};
